import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { brandSecondary, header, hotPink, nameCircles, titles, warningDark } from '../../../../web/styles/colors';
import { CssSelectors, DefaultBorder, Layouts, truncateTextStyle } from '../../../../web/styles/styles';

const { colors, typography } = THEME;
export const styleSheet = StyleSheet.create({
	body: {
		...Layouts.verticalStack(20),
	},
	checkboxLabel: {
		alignItems: 'center',
		color: colors.text.main,
		cursor: 'pointer',
		display: 'flex',
		fontSize: typography.fontSizes.xs,
	},
	draftsSectionTitle: {
		color: hotPink,
	},
	draggableAccordionHeader: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
	},
	draggableAccordionHeaderTitle: {
		color: titles,
		fontSize: '1.25rem',
	},
	draggableAccordionHeaderTitleUncategorized: {
		color: warningDark,
	},
	draggableAccordionHeaderTotal: {
		color: header,
		marginRight: '2rem',
	},
	draggableAccordionHeaderTotalExtendedMargin: {
		marginRight: '5rem',
	},
	draggableAccordionHeaderTrashIcon: {
		cursor: 'pointer',
		marginRight: '2rem',
		verticalAlign: 'middle',
	},
	draggableAccordionHeaderUnpublished: {
		color: hotPink,
		fontSize: '1.125rem',
		marginRight: '2rem',
	},
	dropdownMenu: {
		position: 'relative',
	},
	dropdownTrigger: {
		border: DefaultBorder,
		borderRadius: 3,
		color: header,
		fontSize: 14,
		maxWidth: 300,
		minWidth: 160,
		padding: 8,
		...CssSelectors.allChildren(
			{
				...truncateTextStyle,
			},
			'.select-box-trigger-content'
		),
	},
	headerTitle: {
		color: titles,
		fontSize: 24,
	},
	inputTitle: {
		color: titles,
		fontSize: 14,
		margin: '10px 0 5px',
	},
	invert: {
		transform: 'rotate3d(0,0,1,180deg)',
	},
	modalButtons: {
		marginTop: 20,
		...Layouts.horizontalStack(20),
	},
	modalTitle: {
		color: brandSecondary,
		fontSize: 18,
	},
	newCategoryInput: {},
	sectionTitle: {
		color: titles,
		fontSize: 18,
	},
	throwTemplateInput: {
		width: 100,
	},
	topLevelDraggable: {
		border: `1px solid ${nameCircles}`,
		borderRadius: 3,
		boxShadow: '0px 0px 6px #8b8b8b33',
		boxSizing: 'border-box',
		marginBottom: 20,
		minHeight: 60,
		overflowY: 'hidden',
		padding: '0 2rem 0 1rem',
	},
	topLevelDraggableTitleRow: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		...CssSelectors.allChildren(
			{
				marginLeft: '1rem',
			},
			':not(:first-child)'
		),
	},
	topLevelDraggableTitleSection: {
		alignItems: 'center',
		display: 'flex',
	},
	topLevelDraggableTrigger: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		flex: 1,
	},
	topLevelDraggableTriggerChevron: {
		cursor: 'pointer',
		marginLeft: '0.5rem',
	},
	topLevelDraggableTriggerContent: {
		flex: 1,
	},
	topLevelExpandableBody: {
		height: 0,
		overflow: 'hidden',
		transition: 'height .25s ease-in-out',
	},
	topLevelExpandableBodyExpanded: {
		height: 'initial',
	},
});
